


















































    import {Vue, Component, Watch, Mixins} from 'vue-property-decorator';
    import insertTextAtCursor from 'insert-text-at-cursor';
    import VueMarkdown from 'vue-markdown';
    import ValidationMixin from '@/mixins/ValidationMixin.vue';
    import GlobalAlertMixin from '@/mixins/GlobalAlertMixin.vue';
    import {nil, POST_STATUS} from '@/common';
    import UserRoleMixin from '@/mixins/UserRoleMixin.vue';
    import {DateTime} from 'luxon';
    import postDefault from '@/instance-defaults/postDefault';
    import SelectImportedFilesDialog from '@/components/Views/Dashboard/Import & Export/SelectImportedFilesDialog.vue';
    import ImportDialog from '@/components/Views/Dashboard/Import & Export/ImportDialog.vue';
    @Component({
        components: {
            ImportDialog,
            SelectImportedFilesDialog,
            VueMarkdown
        },
    })
    export default class PublishHome extends Mixins(ValidationMixin, GlobalAlertMixin, UserRoleMixin) {
        public post = null;
        public loading = false;
        public formValid = false;
        public permalinkDirty = false;
        public errorMessage = '';
        public editedItem = postDefault;
        public statuses = [
            {key:POST_STATUS.DRAFT, label:"Draft"},
            {key:POST_STATUS.PUBLISHED, label:"Published"},
            {key:POST_STATUS.TRASHED, label:"Trashed"},
        ];

        @Watch('editedItem.title')
        onTitleChanged(value: string, oldValue: string){
            if(this.editedItem.permalinkDirty || this.postExists) return;
            this.editedItem.permalink = this.slug;
        }

        @Watch('permalinkDirty')
        onPermalinkDirtyChanged(value: boolean, oldValue: boolean){
            if(!value && oldValue){
                this.editedItem.permalink = this.slug;
            }
        }
        public onImport(e){
            insertTextAtCursor(this.$refs.textArea as HTMLTextAreaElement, `![Image](${e.file})\``);
            this.$refs.importImageDialog.open = false;
        }
        public get selectedBlogImage() {
            const obj = {};
            // if (nil(this.vendor) || nil(this.vendor.profileImage)) { return obj; }
            // obj[this.vendor.profileImage] = true;
            return obj;
        }
        public set selectedBlogImage(value) {
            const k = Object.keys(value)
            if(k.length > 0 && value[k[0]]){
                this.insertImage(k[0]);
            } else {
                this.showAlert('Could not get image', 'error');
            }
            this.$refs.importImageDialog.open = false;
        }
        public async insertImage(id){
            const {Upload} = this.$FeathersVuex;
            const f = await Upload.get(id);
            insertTextAtCursor(this.$refs.textArea as HTMLTextAreaElement, `![Image](${f.file})\``);
            /*this.editedItem.body = `${this.editedItem.body}
![Image](${f.file})`*/
        }
        public escapeEntities(){
            this.editedItem.permalink = this.slugify(this.editedItem.permalink);
        }
        public async onSubmit(){
            if (this.formValid) {
                this.loading = true;
                try {
                    const p = this.postExists ? await this.updatePost() : await this.createPost();
                    setTimeout(() => {
                        this.$bus.$emit('showAlert', {
                            type: 'success',
                            text: 'Your post has been created',
                            timeout:7000,
                            button: {
                                text: 'View',
                                link: `/blog/${this.editedItem.permalink}`,
                            },
                        });
                        this.loading = false;
                        this.post = p;
                    }, 2500);
                } catch (e) {
                    console.log(e);
                    this.loading = false;
                    this.showAlert(`Error encountered trying to ${this.action} this post!`, 'error');
                }
            } else {
                //this.errorMessage = this.getErrorMessage();
            }
        }
        async createPost(){
            const {Post} = this.$FeathersVuex;
            const post = new Post({
                author:this.user._id,
                authorName:'',
                date:DateTime.utc().toISO(),
                title:this.editedItem.title,
                //image:'',
                permalink:this.editedItem.permalink,
                body:this.editedItem.body,
            });
            return await post.create();
        }
        async updatePost(){
            if(this.postExists){
                this.post.authorName = '';
                this.post.date = DateTime.utc().toISO();
                this.post.title = this.editedItem.title;
                //image
                this.post.permalink = this.editedItem.permalink;
                this.post.title = this.editedItem.title;
                this.post.body = this.editedItem.body;
                await this.post.save();
                return this.post;
            } else {
                throw Error("Null post, can't save.")
            }
        }
        mounted(){
            this.refreshPost();
        }
        created(){
            this.refreshPost();
        }
        @Watch('$route')
        public onRouteChanged(value: string, oldValue: string) {
            this.refreshPost();
        }

        public async refreshPost() {
            this.editedItem = Object.assign({}, postDefault);
            if(nil(this.$route.params.id)) return;
            this.post = await this.$FeathersVuex.Post.get(this.$route.params.id);
            if(nil(this.post)) return;
            this.editedItem = Object.assign({}, this.post);
            (this.$refs.statusSelect as any).selectItem(this.editedItem.status);
        }

        get slug(){
            return this.slugify(this.editedItem.title);
        }
        slugify(string) {
            //thanks https://medium.com/@mhagemann/the-ultimate-way-to-slugify-a-url-string-in-javascript-b8e4a0d849e1
            const a = 'àáäâãåăæąçćčđďèéěėëêęğǵḧìíïîįłḿǹńňñòóöôœøṕŕřßşśšșťțùúüûǘůűūųẃẍÿýźžż·/_,:;'
            const b = 'aaaaaaaaacccddeeeeeeegghiiiiilmnnnnooooooprrsssssttuuuuuuuuuwxyyzzz------'
            const p = new RegExp(a.split('').join('|'), 'g')

            return string.toString().toLowerCase()
                .replace(/\s+/g, '-') // Replace spaces with -
                .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
                .replace(/&/g, '-and-') // Replace & with 'and'
                .replace(/[^\w\-]+/g, '') // Remove all non-word characters
                .replace(/\-\-+/g, '-') // Replace multiple - with single -
                .replace(/^-+/, '') // Trim - from start of text
                .replace(/-+$/, '') // Trim - from end of text
        }
        get postExists(){
           return !nil(this.post);
        }
        get titleAndBody(){
            return `# ${this.editedItem.title}
${this.editedItem.body}`;
        }
        get action (){
            if(this.editedItem.status === POST_STATUS.DRAFT) return "Save Draft";
            if(this.editedItem.status === POST_STATUS.TRASHED) return "Send To Trash";
            if(this.editedItem.status === POST_STATUS.PUBLISHED && this.postExists) return "Update";
            return "Save";
        }
    }
